import React from 'react';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, GridToolbarContainer, GridCellEditStopReasons, GridCellEditCommitParams, MuiEvent } from '@mui/x-data-grid';
import { Box, Button, Stack } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DraggableDialog from '../../CustomDialogs/DraggableDialog';
import PropTypes from "prop-types";
import ProductListData from '../../ProductList/ProductListData';
import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';

export default function ProductList(props) {
    const { defaultValue } = props
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [searchData, setSearchData] = React.useState("")
    const [openModel, setOpenModel] = React.useState(false)
    const [typeModel, setTypeModel] = React.useState(false)
    const [clickRowsID, setClickRowsID] = React.useState("")
    const [buttonText, setButtonText] = React.useState("")
    const [title, setTitle] = React.useState("เลือกสินค้า")
    const [sendData, setSendData] = React.useState(false)
    React.useEffect(() => {
        getData()
        return () => {
        }
    }, [])

    React.useEffect(() => {
        // console.log("defaultValue", defaultValue.length);
        if (typeof defaultValue !== "undefined") {
            if (defaultValue.length > 0) {
                setData(defaultValue)
            }
        }
        return () => {
        }
    }, [defaultValue])

    React.useEffect(() => {
        if (sendData === true) {
            props.resultData(data)
            setSendData(false)
        }
        return () => {
        }
    }, [data])
    const getData = async () => {
        let rows = []
        for (let index = 0; index < 5; index++) {
            await rows.push({ id: index + 1, code: "" })
        }
        await setData(rows)
    }

    const columns = [
        { field: 'id', hide: true },
        {
            field: 'code',
            headerName: 'รหัส',
            width: 30,
            editable: true,
            flex: 1
        },
        {
            field: 'selectProduct',
            headerName: '',
            sortable: false,
            width: 34,
            renderCell: (params) => {

                const onClick = () => {
                    setTypeModel("inRow")
                    setClickRowsID(params.id);
                    setOpenModel(true)
                };
                return <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>Click</SearchRoundedIcon>;
            },
        },
    ];


    const searchInputKeyUp = (e) => {

        if (e.key === "Enter") {
            setSearchData(e.target.value)
        }
    }

    const handleAddRows = async () => {

        let arrObjIds = await data.map(elements => {
            return elements.id
        });
        let ids = 0
        if (arrObjIds.length > 0) {
            ids = await Math.max(...arrObjIds)
            // console.log("ids", ids)
        }
        //  await setData(...data, { id: ids + 1, code: "" })
        await setData(data => [...data, { id: ids + 1, code: "" }])
        //  console.log("ids", ids)
        // setOpenModel(true)
        // setTypeModel("addButton")
    }

    const CustomToolbar = () => {
        return (
            <>
                <GridToolbarContainer id={`GridToolbarContainers`} >
                    <Button Button variant="outlined" startIcon={<PlaylistAddRoundedIcon />} size='small' sx={{ marginRight: 2 }} onClick={_ => handleAddRows()}>
                        เพิ่ม
                    </Button>
                    {selectionModel.length > 0 ?
                        <Button variant="outlined" startIcon={<DeleteIcon />} size='small' sx={{ marginRight: 2 }} onClick={_ => handleDeleteRows()}>
                            ลบ
                        </Button> : ""
                    }
                    <GridToolbarQuickFilter />

                </GridToolbarContainer >
            </>
        );
    }
    const resultData = async (e) => {
        console.log(e);
        let resultFilter = await data.filter((elem) => {
            return e.find((el => {
                return el.code === elem.code
            }))
        })


        let arrObjIds = await data.map(elements => {
            return elements.id;
        });
        let maxID = 0
        if (arrObjIds.length > 0) {
            maxID = await Math.max(...arrObjIds);
        } else {
            await setData([])
        }
        if (maxID === 0) {
            maxID + 1
        }
        //console.log("resultData maxID", maxID, "resultFilter", resultFilter);  
        await setSendData(true)
        if (resultFilter.length <= 0) {
            if (typeModel === "inRow") {
                // 👇️ passing function to setData method
                setData(data => {
                    const newState = data.map(obj => {
                        // 👇️ if id equals 2, update the country property
                        if (obj.id === clickRowsID) {
                            return { ...obj, code: e[0]["code"] };
                        }
                        // 👇️ otherwise return the object as is
                        return obj;
                    });
                    return newState;
                });

            } else {
                await setData(data => [...data, { id: maxID + 1, code: e[0]["code"] }])
            }

            if (typeModel === "inRow") {
                await setOpenModel(false)
            }
        }
    }
    // action delete button
    const handleDeleteRows = async () => {
        console.log(selectionModel);
        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return !selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        }
        await setSendData(true)
        await setData(result)

    }

    //    const processRowUpdate = React.useCallback(e => { console.log("processRowUpdate", e); }, []);

    // async (e) => {
    // console.log("processRowUpdate", e.id)
    // 👇️ passing function to setData method
    // setData(data => {
    //     const newState = data.map(obj => {
    //         // 👇️ if id equals 2, update the country property
    //         if (obj.id === e.id) {
    //             return { ...obj, code: e.code };
    //         }
    //         // 👇️ otherwise return the object as is
    //         return obj;
    //     });
    //     return newState;
    // });
    // }

    const onCellEditStop = (e) => {
        console.log(e)
    }

    const onCellEditCommit = (cellData) => {
        const { id, field, value } = cellData;

        console.log("onCellEditCommit", cellData);

    }

    const processRowUpdate = async (newRow) => {
        // console.log(updatedRow);
        console.log("processRowUpdate", newRow)
        // 👇️ passing function to setData method
        await setData(data => {
            const newState = data.map(obj => {
                // 👇️ if id equals 2, update the country property
                if (obj.id === newRow.id) {
                    return { ...obj, code: newRow.code };
                }
                // 👇️ otherwise return the object as is
                return obj;
            });

            return newState;
        });
        await console.log("processRowUpdate", data)
        const updatedRow = await { ...newRow, isNew: false };
        return await updatedRow;
    };

    return (
        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
            {loading == true ? "กำลังโหลด..." :
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}

                    processRowUpdate={processRowUpdate}


                    rows={data}
                    columns={columns}
                    sx={{
                        fontFamily: "Customfont !important"
                    }}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10]}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(newSelectionModel) => {
                        setSelectionModel(newSelectionModel);
                    }}
                    selectionModel={selectionModel}


                    onCellEditCommit={e => console.log(e)}

                    onCellEditStop={(params, event) => {
                        // console.log("params", data);
                        if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                            event.defaultMuiPrevented = false;
                        }
                    }}

                    components={{
                        Toolbar: CustomToolbar,
                        // LoadingOverlay: LinearProgress,
                    }}
                />}
            <DraggableDialog open={openModel} title={title} buttonText={buttonText} closeDialog={_ => setOpenModel(false)} onButtonClose={true}>
                <ProductListData resultData={e => resultData(e)} />
            </DraggableDialog>
        </Box>

    )

}

ProductList.propTypes = {
    defaultValue: PropTypes.array
}